/* eslint-disable no-param-reassign */

const state = {
  desabilitarBotao: false,
}

const getters = {
  desabilitarBotao: state_ => state_.desabilitarBotao,
}

const actions = {
  setDesabilitarBotao({ commit }, desabilitar) {
    commit('SET_DESABILITAR_BOTAO', desabilitar)
  },
}

const mutations = {
  SET_DESABILITAR_BOTAO(state_, desabilitar) {
    state_.desabilitarBotao = desabilitar
  },
}

export default {
  namespaced: true,
  getters,
  actions,
  mutations,
  state: () => state,
}
